module.exports = __webpack_public_path__ + "static/media/video-placeholder.bfe15161.svg";